module.exports = __webpack_public_path__ + "img/sber.a2d0d3c4.png";